'use strict';


class GoogleAnalytics {
    constructor(options) {
        this.opt = options;
    }
    reachGoal(goal, params) {
        try {
            this.counter('send', 'event', goal, params);
            console.info(`[ GoogleAnalytics ] Goal ${goal} is reached successfully`);
        } catch (err) {
            console.error(`[ GoogleAnalytics ] Can't reach goal ${goal}`, err);
        }
    }
    setParams(params) {
        try {
            this.counter('set', params);
            console.info('[ GoogleAnalytics ] Params are set successfully');
        } catch (err) {
            console.error('[ GoogleAnalytics ] Can\'t set params', err);
        }
    }
    get counter() {
        if (!this.__counter) {
            this.__counter = window['ga'];
        }
        return this.__counter;
    }
}

let googleAnalytics = new GoogleAnalytics();


export {
    googleAnalytics
};
